module.exports = new __parcel__URL__("train_100_active.c76c5397.png").toString();